export default __webpack_public_path__ + "static/media/join1.46eb438f.jpeg";